export default "__VITE_ASSET__fcafd6c7__"